import {
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import React, { useContext, useState } from 'react';
import { BusinessContext } from '../BusinessProvider/BusinessProvider';
import { getFullName } from '../utils/utils';
import EditIcon from '@material-ui/icons/Edit';
import { EditBusinessManagerModal } from './Modals/EditBusinessManagerModal';

const BusinessEditGestionnaire = () => {
  const classes = useStyles();
  const { businessState, canEditBusiness } = useContext(BusinessContext);
  const [openModal, setOpenModal] = useState<boolean>(false);
  return (
    <>
      <Grid item xs={12} sm={3} className={classes.left}>
        <Typography className={classes.label}>Gestionnaire :</Typography>
      </Grid>
      <Grid item xs={11} sm={8} className={classes.left}>
        <Typography>
          {getFullName({
            firstName: businessState?.manager?.firstName || '',
            lastName: businessState?.manager?.lastName || '',
          })}
        </Typography>
      </Grid>
      <Grid item xs={1} sm={1} className={classes.right}>
        {canEditBusiness && (
          <EditIcon
            className={classes.icon}
            onClick={() => setOpenModal(true)}
          />
        )}
      </Grid>
      {openModal && (
        <EditBusinessManagerModal onClose={() => setOpenModal(false)} />
      )}
    </>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    left: {
      display: 'flex',
      justifyContent: 'left',
      alignItems: 'center',
    },
    label: {
      fontWeight: 'bold',
    },
    right: {
      display: 'flex',
      justifyContent: 'right',
      alignItems: 'center',
    },
    icon: {
      height: 15,
      color: '#FF4340',
      cursor: 'pointer',
    },
    input: {
      flex: 1,
    },
    disabled: {
      color: 'black',
    },
  }),
);

export default BusinessEditGestionnaire;
